// extracted by mini-css-extract-plugin
export default {"wrapper":"BuildingsList_wrapper__kMvYu","table":"BuildingsList_table__K63CV"};